import { useQuery } from '@tanstack/react-query';
import { APITypes } from '../../primary-record-types';
import { getIntl } from '../../utils/intl';
import urls from '../../utils/urls';
import { appAPI } from '../../utils/api';
import { getTransferRequestCacheKey } from './cacheKeys';
import { useQueryErrorNotify } from '../useQueryCallbacks';

const intl = getIntl('useProfilePendingTransferRequest', {
    errorLoadingTransferRequests: 'Error occurred loading pending profile transfer request',
});

export type UseProfilePendingTransferRequestArgs = {
    medicalProfileId: string;
    transferRequestId: string;
};

export type UseProfilePendingTransferRequestReturnValue = {
    profilePendingTransferRequest: APITypes.medicalProfileService.PendingTransferRequestResponse | null;
    isLoading: boolean;
};

export default function useProfilePendingTransferRequest({
    medicalProfileId,
    transferRequestId,
}: UseProfilePendingTransferRequestArgs): UseProfilePendingTransferRequestReturnValue {
    const transferRequestQuery = useQuery({
        queryKey: getTransferRequestCacheKey(medicalProfileId, transferRequestId),
        queryFn: async () => {
            const response = await appAPI.get<APITypes.medicalProfileService.PendingTransferRequestResponse>(
                urls.api.ownershipTransfer.pendingTransferRequest(medicalProfileId, transferRequestId),
            );
            return response;
        },
    });
    useQueryErrorNotify(transferRequestQuery, intl('errorLoadingTransferRequests'));

    return {
        profilePendingTransferRequest: transferRequestQuery.data || null,
        isLoading: transferRequestQuery.isLoading,
    };
}
